import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="w-full px-4 md:px-8 pt-28 md:pt-36 pb-20 flex flex-col items-center justify-center text-center min-h-[70vh]">
      <span className="relative flex items-center justify-center w-20 h-20 rounded-full bg-primary-100 text-primary-600 mb-6">
        <i className="ri-emotion-sad-line text-4xl" />
      </span>
      <h1 className="text-2xl md:text-3xl font-black text-foreground-950">页面走丢了</h1>
      <p className="mt-2 text-sm md:text-base text-foreground-500 max-w-md">
        抱歉，你访问的页面不存在或已被移除。不妨回到首页，继续探索更多精彩视频。
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 whitespace-nowrap cursor-pointer transition-colors"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-200 bg-background-50 text-foreground-700 text-sm font-semibold hover:border-primary-300 hover:text-primary-600 whitespace-nowrap cursor-pointer transition-colors"
        >
          <i className="ri-search-line" />
          去搜索视频
        </Link>
      </div>
    </div>
  );
}